var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MySearch',{ref:"search",attrs:{"selectFiles":_vm.selection}},[_c('Button',{attrs:{"type":"primary"},on:{"click":_vm.handleToName}},[_vm._v("修改查档信息登记")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }